import * as action from "./actions";

export const getMode = id => {
  return {
    type: action.GET_MODE,
    payload: id
  };
};

export const setMode = mode => {
  return {
    type: action.SET_MODE,
    payload: mode
  };
};

const ACTION_HANDLERS = {
  [action.GET_MODE]: (state, action) => {
    return { ...state };
  },
  [action.SET_MODE]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = { mode: 0 };

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
